import axios from "axios";
import authHeader from "./authHeader";
import { API_URL } from "./const";

export interface LanguagePreferenceDTO {
  language: string;
}

class LanguageService {
  async getUserLanguage() {
    return axios.get<LanguagePreferenceDTO>(`${API_URL}user/language`, { headers: authHeader() });
  }

  async updateUserLanguage(language: string) {
    return axios.patch(
      `${API_URL}user/language`,
      { language },
      { headers: authHeader() }
    );
  }
}

const languageService = new LanguageService();
export default languageService; 